import { createIcon } from "@chakra-ui/react";

export const UpvoteIcon = createIcon({
  displayName: "UpvoteIcon",
  viewBox: "0 0 24 24", // Standard 24x24 viewBox for consistency
  path: (
    <>
      {/* Path for the inner solid fill */}
      {/* It will use the 'fill' prop passed to the Chakra UI icon */}
      <path
        d="M9 14V21H15V14H21L12 3L3 14H9Z"
        fill="inherit" // This will inherit the 'fill' prop
        stroke="none" // Ensure no stroke on this path
      />

      {/* Path for the outline */}
      {/* It will use the 'color' prop (which translates to SVG 'stroke') */}
      <path
        d="M12 2.5C12.15 2.5 12.2918 2.56753 12.3867 2.68359L21.3867 13.6836C21.509 13.833 21.5347 14.0394 21.4522 14.2139C21.3694 14.3885 21.1932 14.5 21 14.5H15.5V21C15.5 21.2761 15.2762 21.5 15 21.5H9.00002C8.72388 21.5 8.50002 21.2761 8.50002 21V14.5H3.00002C2.80683 14.5 2.63061 14.3885 2.54788 14.2139C2.46533 14.0394 2.49104 13.833 2.61331 13.6836L11.6133 2.68359L11.6924 2.60547C11.7794 2.53762 11.8876 2.5 12 2.5ZM4.05471 13.5H9.00002C9.27617 13.5 9.50002 13.7239 9.50002 14V20.5H14.5V14C14.5 13.7239 14.7239 13.5 15 13.5H19.9453L12 3.78906L4.05471 13.5Z"
        stroke="currentColor" // This will inherit the 'color' prop
        strokeWidth="1" // Adjust outline thickness as needed
        fill="none" // Important: Do not fill this path, only stroke it
      />
    </>
  ),
});
